import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import VehiclePositionLast from './vehicle-position-last';
import VehiclePositionLastDetail from './vehicle-position-last-detail';
import VehiclePositionLastUpdate from './vehicle-position-last-update';
import VehiclePositionLastDeleteDialog from './vehicle-position-last-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={VehiclePositionLastUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={VehiclePositionLastUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={VehiclePositionLastDetail} />
      <ErrorBoundaryRoute path={match.url} component={VehiclePositionLast} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={VehiclePositionLastDeleteDialog} />
  </>
);

export default Routes;
